import React, { useContext, useEffect } from "react";
import { motion } from "framer-motion";
import { useSearchParams, Navigate } from "react-router-dom";
import DocumentsProvider from "../Hooks/DocumentsProvider";
import { useDocuments } from "../Hooks/DocumentsContext";
import Markdown from "react-markdown";
import rehypeSlug from "rehype-slug";
import "./Styles/DocumentPage.scss";
import { LanuageContext } from "../Hooks/LanguageContext";
import { SettingsModel } from "../Models/SettingsModel";

const DocumentPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { state, initializeDocuments } = useDocuments();
  const language = useContext(LanuageContext);

  const hasQueryParams = Array.from(searchParams.entries()).length > 0;
  const lang = language ?? SettingsModel.defaultLanguage;

  useEffect(() => {
    if (state.documents.length === 0 && !state.loading) {
      initializeDocuments(lang);
    }
  }, []);

  if (!hasQueryParams) {
    return <Navigate to="/" replace />;
  }

  const docId = searchParams.get("id");
  const selectedDoc = state.documents.find((doc) => doc.id === docId);

  const documentBaseUrl = `${process.env.PUBLIC_URL ?? ""}${SettingsModel.documentUri}${lang}/`;
  const resolveDocumentUrl = (url: string): string => {
    if (/^(?:[a-z][a-z0-9+.-]*:|\/|#)/i.test(url)) {
      return url;
    }
    return `${documentBaseUrl}${url}`;
  };

  return (
    <motion.div className="DocumentPageWrapper">
      <p className="DocumentTitle">{selectedDoc?.title}</p>
      <DocumentsProvider>
        <Markdown
          urlTransform={resolveDocumentUrl}
          rehypePlugins={[rehypeSlug]}
          children={selectedDoc ? selectedDoc.content : "Document not found."}
        />
      </DocumentsProvider>
    </motion.div>
  );
};

export default DocumentPage;
